import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <path d="M6.7 12.7C6.3 13.1 5.7 13.1 5.3 12.7C4.9 12.3 4.9 11.7 5.3 11.3L8.6 8 5.3 4.7C4.9 4.3 4.9 3.7 5.3 3.3C5.7 2.9 6.3 2.9 6.7 3.3L10.7 7.3C11.1 7.7 11.1 8.3 10.7 8.7L6.7 12.7Z" />,
  'ArrowRight',
);
